import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  CampaignUmbrellaListStateType,
  SetQueryPayloadActionType,
} from 'features/CampaignAndDiscount/@types/campaignUmbrellaList'

export const SLICE_NAME = 'campaignUmbrellaList'

export const initialState: CampaignUmbrellaListStateType = {
  isLoading: false,
  list: [],
  query: {
    status: { value: '', name: '' },
    page_index: 0,
    page_size: 20,
    campaign_theme: '',
    created_at: '',
  },
}

const campaignUmbrellaList = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setList: (state, action: PayloadAction<CampaignUmbrellaListStateType['list']>) => {
      state.list = action.payload
    },
    setQuery: (state, action: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = { ...state.query, ...action.payload }
    },
  },
})

export const { setIsLoading, reset, setList, setQuery } = campaignUmbrellaList.actions
export default campaignUmbrellaList.reducer
